// Common types

export * from './timetable';

export * from './forms';

export type HSMSParentRoute = {
  id: string;
  name: string;
};

export type HSMSRoute = {
  id: string;
  name: string;
  path: string | null;
  componentName: string | null;
  iconName: string;
  dummy: boolean | null;
  showInMenu: boolean;
  order: number | null;
  parent: HSMSParentRoute | null;
  children?: HSMSRoute[];
};

export type FileToBeUploaded = {
  fileExtension: string;
  fileURL?: string;
  file?: Blob | File;
  contentType: string;
  id: string;
  url?: string;
  uploadURL?: string;
};

export enum SemesterType {
  '1:1' = '1:1',
  '1:2' = '1:2',
  '2:1' = '2:1',
  '2:2' = '2:2',
  '3:1' = '3:1',
  '3:2' = '3:2',
  '4:1' = '4:1',
  '4:2' = '4:2',
}

export interface HSMSContainers {
  [key: string]: React.FC;
}

export interface MessageType {
  content: string;
}

export enum WeekDay {
  'monday' = 'monday',
  'tuesday' = 'tuesday',
  'wednesday' = 'wednesday',
  'thursday' = 'thursday',
  'friday' = 'friday',
  'saturday' = 'saturday',
  'sunday' = 'sunday',
}
